import { ComponentBase } from '../../../component-base';
import { IMouseRelease } from '../Interfaces';
import { DrawingsHolderService } from '../drawings-holder.service';
import { Injectable } from '@angular/core';
import { PositionCalculatorService } from '../position-calculator.service';
import { Selectable } from '../object3D/Selectable';
import {
  SelectableLine,
  Line,
  PolyLine,
  Arc,
  SelectablePicket,
  DoublePost,
  SingleCornerPost,
  TerminationPost,
  SelectableIntermediatePost
} from '../object3D';
import { Mesh } from '../object3D/Arc/Mesh';
import { common } from '../common';
import { Subject } from 'rxjs';

declare let THREE: any;

@Injectable()
export class SelectComponent extends ComponentBase implements IMouseRelease {
  private raycaster = new THREE.Raycaster(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -1, 0));
  private selectedObject: Selectable | undefined;
  private selectedObjects: Selectable[] = [];

  public SelectModeOn = new Subject<boolean>();
  picketSelected: boolean = false;
  postSelected: boolean = false;
  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService
  ) {
    super();

    this.disable();
  }

  enable() {
    if (!this.Enable) {
      this.Enable = true;
      this.SelectModeOn.next(true);
    }
  }

  disable() {
    if (this.Enable) {
      this.Enable = false;
      this.SelectModeOn.next(false);
    }
  }

  mouseUp(e: MouseEvent) {
    const { onSelect, canvas } = this.drawings;
    if (!e.ctrlKey) {
      this.selectedObjects.forEach(obj => {
        if (obj) {
          obj.unhighlight();
        }
      });
      this.selectedObjects = [];
      this.picketSelected = false;
      this.postSelected = false;
    }
    const origin = this.positionCalculator.calculate(e).setY(common.raycastAtY);
    this.raycaster.ray.origin.copy(origin);
    this.raycaster.linePrecision = 10;
    const selectable = canvas.children.filter(ch => ch instanceof Selectable);
    const selectableLines = canvas.children.filter(
      ch => ch instanceof SelectableLine || ch instanceof PolyLine || ch instanceof Arc
    );
    const lines = [];
    selectableLines.forEach(sLine => {
      const line = sLine.children.filter(ch => ch instanceof Line || ch instanceof Mesh);
      if (line) {
        lines.push(line[0]);
      }
    });
    const lineIntersection = this.raycaster.intersectObjects(lines, true);
    let result = false;
    if (lineIntersection.length !== 0 && !this.picketSelected && !this.postSelected) {
      if (this.selectedObject) {
        this.selectedObjects.forEach(obj => {
          obj.unhighlight();
        });
      }
      const selectedLine = lineIntersection.pop().object;
      this.selectedObject = selectedLine.parent;
      this.selectedObject.highlight();
      this.selectedObjects.push(this.selectedObject);
      onSelect.next(this.selectedObjects);
      result = true;
    } else {
      const intersection = this.raycaster.intersectObjects(selectable);
      if (intersection.length !== 0) {

        if ((this.selectedObject && !e.ctrlKey)
        || !(this.selectedObject instanceof SelectablePicket
          || this.selectedObject instanceof DoublePost
          || this.selectedObject instanceof SingleCornerPost
          || this.selectedObject instanceof TerminationPost
          || this.selectedObject instanceof SelectableIntermediatePost)) {
          this.selectedObjects.forEach(obj => {
            obj.unhighlight();
          });
          this.selectedObjects = [];
        }

        this.selectedObject = intersection.pop().object;
        if (this.selectedObject instanceof SelectablePicket) {
          if (!this.postSelected) {
            this.picketSelected = true;
            this.selectedObject.highlight();
            this.selectedObjects.push(this.selectedObject);
            onSelect.next(this.selectedObjects);
            result = true;
          }
        } else if (
          this.selectedObject instanceof DoublePost ||
          this.selectedObject instanceof SingleCornerPost ||
          this.selectedObject instanceof TerminationPost ||
          this.selectedObject instanceof SelectableIntermediatePost
        ) {
          if (!this.picketSelected) {
            this.postSelected = true;
            this.selectedObject.highlight();
            this.selectedObjects.push(this.selectedObject);
            onSelect.next(this.selectedObjects);
            result = true;
          }
        } else {
          this.selectedObject.highlight();
          // if (this.selectedObject instanceof PolyLine) {
          //   let info = this.selectedObject.getInfo();
          //   this.selectedObject = new PolyLine();
          //   this.drawings.canvas.add(this.selectedObject);
          //   this.selectedObject.rebuild(info);
          // }
          this.selectedObjects.push(this.selectedObject);
          onSelect.next(this.selectedObjects);
          result = true;
        }
      } else {
        if (this.selectedObject && !this.picketSelected && !this.postSelected) {
          this.selectedObjects.forEach(obj => {
            obj.unhighlight();
          });
          this.selectedObject = null;
          this.selectedObjects.push(this.selectedObject);
          onSelect.next(this.selectedObjects);
        }
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/SelectComponent.ts